const SESSION_KEY = 'superoti.warehouse.session'

export type WarehouseSession = {
  accessToken: string
  userId: string
  userName: string
  roleCode: 'HEAD_WAREHOUSE' | 'ASSISTANT_HEAD_WAREHOUSE' | 'STAFF_WAREHOUSE'
  authority: 'full' | 'attendance_only'
  headPresent: boolean
  brandId: string
  brandCode: string
  warehouseId: string
  loggedInAt: string
}

export function getWarehouseSession(): WarehouseSession | null {
  try {
    const raw = localStorage.getItem(SESSION_KEY)
    if (!raw) return null
    return JSON.parse(raw) as WarehouseSession
  } catch {
    return null
  }
}

export function hasWarehouseSession(): boolean {
  return getWarehouseSession() !== null
}

export function setWarehouseSession(session: WarehouseSession): void {
  localStorage.setItem(SESSION_KEY, JSON.stringify(session))
}

export function updateWarehouseSessionAuthority(
  authority: WarehouseSession['authority'],
  headPresent: WarehouseSession['headPresent'],
): void {
  const session = getWarehouseSession()
  if (!session) return
  setWarehouseSession({ ...session, authority, headPresent })
}

export function clearWarehouseSession(): void {
  localStorage.removeItem(SESSION_KEY)
}
